import BottomNavigationBarView from './bottom_navigation_bar_view'
import SceneView from './scene_view'


class LeafletSetNavigationView {
  constructor(_element, loggerForShowForWidget) {
    this.sceneView = SceneView.register($('.scene'))
    this.bottomNavigationBarView = BottomNavigationBarView.register(
      $('.bottom_navigations_wrapper')
    )
    this.initialize(loggerForShowForWidget)
  }

  initialize(loggerForShowForWidget) {
    const viewState = $('#view_state').data('view-state')
    this.leaflets = viewState.leaflets
    this.currentLeaflet = viewState.current_leaflet

    this.indexByLeafletId = {}
    for (let index = 0; index < this.leaflets.length; index++) {
      var leaflet = this.leaflets[index]
      this.indexByLeafletId[leaflet.id] = index
    }

    loggerForShowForWidget.sendLog()

    this.setAnyViewState()
    return this.assignEvents()
  }

  assignEvents() {
    $('.previous_leaflet_button').on('click', (e) => {
      e.preventDefault()
      this.setPreviousLeaflet()
      this.setAnyViewState()
      this.setImageOverlayLink()
      return this.log()
    })
    $('.next_leaflet_button').on('click', (e) => {
      e.preventDefault()
      this.setNextLeaflet()
      this.setAnyViewState()
      this.setImageOverlayLink()
      return this.log()
    })

    return $('.shop_button')
      .on('mouseover', function () {
        return $(this).find('.navigation_tooltip').show()
      })
      .on('mouseout', function () {
        return $(this).find('.navigation_tooltip').hide()
      })
  }

  setNextLeaflet() {
    if (!this.isNextLeafletAvailable()) {
      return
    }
    return (this.currentLeaflet =
      this.leaflets[this.indexByLeafletId[this.currentLeaflet.id] + 1])
  }

  setPreviousLeaflet() {
    if (!this.isPreviousLeafletAvailable()) {
      return
    }
    return (this.currentLeaflet =
      this.leaflets[this.indexByLeafletId[this.currentLeaflet.id] - 1])
  }

  setAnyViewState() {
    this.setLocation()
    this.setNavigationViewState()
    this.bottomNavigationBarView.setViewState(this.currentLeaflet)
    return this.sceneView.changeLeaflet(this.currentLeaflet)
  }

  setLocation() {
    if (window.history && window.history.pushState) {
      return window.history.pushState({}, null, this.currentLeaflet.url)
    }
  }

  setNavigationViewState() {
    if (this.isNextLeafletAvailable()) {
      $('.next_leaflet_button').show()
      $('.next_shop_button').hide()
      $('.next_weather_dependent_image_button').hide()
    } else {
      $('.next_leaflet_button').hide()
      if ($('.next_weather_dependent_image_button').length > 0) {
        $('.next_weather_dependent_image_button').show()
      } else {
        $('.next_shop_button').show()
      }
    }

    if (this.isPreviousLeafletAvailable()) {
      $('.previous_leaflet_button').show()
      return $('.previous_shop_button').hide()
    } else {
      $('.previous_leaflet_button').hide()
      return $('.previous_shop_button').show()
    }
  }

  setImageOverlayLink() {
    if (this.isImageOverlayLinkAvailable()) {
      return $('.leaflet_image_overlay_link-bottom-right').attr('href', this.currentLeaflet.image_overlay_links[0].url)
    } else {
      return $('.leaflet_image_overlay_link-bottom-right').show()
    }
  }

  isNextLeafletAvailable() {
    return this.indexByLeafletId[this.currentLeaflet.id] < this.leaflets.length - 1
  }

  isPreviousLeafletAvailable() {
    return this.indexByLeafletId[this.currentLeaflet.id] > 0
  }

  isImageOverlayLinkAvailable() {
    return this.currentLeaflet.image_overlay_links !== undefined && this.currentLeaflet.image_overlay_links.length > 0
  }

  log() {
    return $.get(this.currentLeaflet.log_url)
  }
}

export default LeafletSetNavigationView;
